import { createContext } from 'react';

// Create a new context object
const NavigationContext = createContext();

export default NavigationContext;
